import { useState } from 'react';
import { Button, Paper } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

import { columns } from './grid-columns';
import { MarketAreaForm } from './market-area.form';
import { MarketArea } from '../../../models/masters/market-area';
import { marketAreaFormSchema } from './market-area-form.schema';
import { SiTrackGrid } from '../../../components/si-track-grid/si-track-grid';
import { SaveHookFormDialog } from '../../../components/save-hook-form.dialog';
import { marketAreaApiKeyStore } from '../../../api/masters/market-area-api-key-store';
import { SiTrackPage } from '../../../components/si-track-page';
import { GuardedComponent } from '../../../components/guarded-component';
import { UserPermissionName } from '../../../models/user-permission-name';

const styling = {
  paperStyle: { padding: '20px', borderRadius: '20px' },
};

export const MarketAreasPage = () => {
  const [editItem, setEditItem] = useState<Partial<MarketArea>>();

  const handleEditMarketArea = (marketArea: MarketArea) => {
    setEditItem(marketArea);
  };
  const handleEditClose = () => {
    setEditItem(undefined);
  };
  const handleCreateMarketArea = () => {
    setEditItem({});
  };

  const formatSubmitdata = (data: any) => {
    return {
      ...data,
      counties: data.counties?.map((item: any) => item.countyID),
    };
  };

  return (
    <SiTrackPage
      title="Market Areas"
      actionButton={
        <GuardedComponent requiredPermissions={[UserPermissionName.ADD_MARKET_AREA]}>
          <Button
            size="small"
            variant="contained"
            disableElevation={true}
            startIcon={<AddIcon />}
            onClick={handleCreateMarketArea}
          >
            Add Market Area
          </Button>
        </GuardedComponent>
      }
    >
      <Paper elevation={0} style={styling.paperStyle}>
        <SiTrackGrid
          fileTitle='market_area'
          dataItemKey="marketAreaID"
          columns={columns}
          queryConfig={marketAreaApiKeyStore.getMarketAreas()}
          onEdit={handleEditMarketArea}
          deleteMutationConfig={(deleteItem) => marketAreaApiKeyStore.deleteMareketArea(deleteItem.marketAreaID)}
          actionPermissions={{
            edit: UserPermissionName.EDIT_MARKET_AREA,
            delete: UserPermissionName.DELETE_MARKET_AREA,
            export: UserPermissionName.DOWNLOAD_GRID
          }}
        />
        {editItem && (
          <SaveHookFormDialog
            title={editItem.marketAreaID ? 'UPDATE MARKET AREA' : 'CREATE MARKET AREA'}
            config={{
              saveConfig: editItem.marketAreaID
                ? marketAreaApiKeyStore.updateMarketArea()
                : marketAreaApiKeyStore.createMarketArea(),
              invalidateRoute: () => marketAreaApiKeyStore.getMarketAreas(),
            }}
            data={editItem}
            yupSchema={marketAreaFormSchema}
            formatSubmitdata={formatSubmitdata}
            onClose={handleEditClose}
            size="md"
          >
            <MarketAreaForm />
          </SaveHookFormDialog>
        )}
      </Paper>
    </SiTrackPage>
  );
};
